import { usePipelineJobs } from 'src/api/queries';
import { MACHINE_COPY, buildJobBoard } from 'src/lib/jobBoard';

/**
 * Whether the machine is running, on every screen.
 *
 * This is the one fact that separates operating a system from reading its output, and until now it
 * lived on a single screen. The box is asleep most of the day and a mañanera takes hours, so "is
 * anything happening" is not answerable by looking at the work — it has to be stated.
 *
 * Three states, from `buildJobBoard`: a queue with work in it and nothing running is the box
 * booting, which is the state an editor mistakes for a breakage and resubmits into.
 *
 * Nothing here animates. Art Direction §4 — the pipeline's progress is state, shown as standing and
 * counts, and a pulsing dot would be the interface performing work it is not doing.
 */
export function MachineState() {
  const jobs = usePipelineJobs({ limit: 25 });

  if (jobs.isPending) return <p className="machine-state machine-state--unknown">Consultando la máquina…</p>;
  if (jobs.isError) return <p className="machine-state machine-state--unknown">No se pudo consultar la máquina</p>;

  const board = buildJobBoard(jobs.data?.jobs ?? [], Date.now(), jobs.data?.machine ?? 'unknown');
  const inFlight = board.running.length + board.queued.length;

  return (
    <p className="machine-state" data-state={board.machine}>
      <span className="machine-state__dot" aria-hidden="true" />
      <span className="machine-state__label">{MACHINE_COPY[board.machine].label}</span>
      <span className="machine-state__count mono">{inFlight > 0 ? `${inFlight} en curso` : 'sin cola'}</span>
    </p>
  );
}
